import React from 'react';

// A single-message state surface (loading, error, expired, already-handled,
// etc.) for the public invitation flow: a heading, a supporting line, and at
// most one action. Purely presentational — no data fetching, no auth calls.
export default function InvitationStatePanel({ title, body, action, tone = 'neutral' }) {
    const headingClassName =
        tone === 'danger'
            ? 'text-lg font-semibold mb-2 text-[color:var(--color-danger)]'
            : 'text-lg font-semibold mb-2 text-[color:var(--text-primary)]';

    return (
        <div>
            <h1 className={headingClassName}>{title}</h1>
            <p className="text-sm text-[color:var(--text-muted)]">{body}</p>
            {action?.onClick ? (
                <button
                    onClick={action.onClick}
                    className="mt-4 px-4 py-2 bg-[color:var(--action-link-color)] text-[color:var(--on-accent)] rounded-md text-sm font-medium"
                >
                    {action.label}
                </button>
            ) : action?.href ? (
                <a
                    href={action.href}
                    className="mt-4 inline-block px-4 py-2 bg-[color:var(--action-link-color)] text-[color:var(--on-accent)] rounded-md text-sm font-medium"
                >
                    {action.label}
                </a>
            ) : null}
        </div>
    );
}
